export const aboutData = {
    title: "Who I am",
    description1: "My name is ",
    description2: "Mehedi Hasan",
    description3: ". I'm a web designer and developer from Naogaon, Rajshahi, Bangladesh.",
    description4: "Love almost all the stacks of Software Engineering. My current stack includes Nodejs, React, NextJs, Redux, Tailwind CSS, Bootstrap,, Material UI, MongoDB, Mysql, PostgreSQL, Firebase, etc.",
    image: 1
}
